import { all, fork, takeLatest, delay, put } from "redux-saga/effects";
import { _types } from "../types";
import _api from "./api";

const { SPONSOR_TYPES, SPONSOR_ITEMS, REQ, CLEAR, STATE, SUCCESS, FAILD} = _types;

export function* sponsorsSaga() {

    yield takeLatest(SPONSOR_TYPES + REQ, function* ({ payload }) {
        const response = yield _api.allSponsorTypes("")
        if (!response) {
          yield put({ type: SPONSOR_TYPES + FAILD, payload: response.error_description });
          yield delay(3000);
          yield put({ type: STATE + CLEAR });
        } 
        else {
            yield put({
                type: SPONSOR_TYPES + SUCCESS,
                payload: response,
            });
        }
    });

    yield takeLatest(SPONSOR_ITEMS + REQ, function* ({ payload }) {
        const response = yield _api.getSponsors(payload)
        if (!response) {
          yield put({ type: SPONSOR_ITEMS + FAILD, payload: response.error_description });
          yield delay(3000);
          yield put({ type: STATE + CLEAR });
        } 
        else {
            yield put({
                type: SPONSOR_ITEMS + SUCCESS,
                payload: response,
            });
        }
    });
}

export default function* rootSaga() {
  yield all([fork(sponsorsSaga)]);
}